import { Component, useEffect, useState, useContext } from "react";
import { useTranslation, withTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { RestAPI } from "@aws-amplify/api-rest";
import { withFormik, Form } from "formik";

import LoadingDialog from "../Utils/LoadingDialog";
import { callSend, RawRow, VinculoNodo, VinculoHidra, Vinculos } from "../Form/Form";
import { ZonesTable } from "../FarmInfo/Tables";
import { FarmContext } from "../../contexts/FarmContext";
import withName from "../../hoc/withName";

import "react-toastify/dist/ReactToastify.css";

const sensor = "sensor_form";

const getSensor = (location) => {
    if (location.search.search("sensor") !== -1) {
        const params = new URLSearchParams(location && location.search);
        const sensor = params.get("sensor");
        return sensor;
    } else {
        return null;
    }
};

const getFarm = (location) => {
    const params = new URLSearchParams(location && location.search);
    const farm = params.get("farm");
    return farm;
};

class SensorForm extends Component {
    render() {
    //const { resetForm, status = {}, canEdit, setStatus, data, t, handleSubmit } = this.props;
        const { data, t, i18n, handleSubmit, farmId, nodoRelacionado, hidraRelacionada, units } = this.props;
        if (!data) return <div className="card col-xl-12 col-lg-12 col-sm-12">No Data</div>;
        //const isEdit = canEdit && status.edit;
        data.campo = farmId;
        return (
            <div className="card">
                <div className="card-body">
                    <Form id={sensor} onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col col-sm-2 col-md-3 col-lg-4' />
                            <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                                <h5 className="card-title"><span>{t("farms.sensor.sensorInfo")}</span></h5>
                            </div>
                            <div className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'>
                                {/*HeaderButtons edit={status.edit} canEdit={canEdit} setStatus={setStatus} resetForm={resetForm} form={sensor} />*/}
                            </div>
                        </div>
                        <div className='linea-titulo' />
                        <div className='row'>
                            <div className='col-12 text-center'>
                                <RawRow
                                    dato1={data.nombre}
                                    nombre1={t("general.name")}
                                    dato2={data.marca_modelo}
                                    nombre2={t("farms.actuator.modelo")}
                                />

                                <RawRow
                                    dato1={data.tipo?(data.tipo[i18n.language] ?? data.tipo["en"]):`sensor.${data.sensor_id}`}
                                    nombre1={t("general.type")}
                                    dato2={t("general.number_unit", { value: { number: data.profundidad, unit: units && units.centi_unidad } })}
                                    nombre2={t("forms.profundidad")}
                                />

                                <VinculoNodo farmId={farmId} nodo_id={data.nodo_id} nodoRelacionado={nodoRelacionado} t={t} />
                                <VinculoHidra farmId={farmId} hidraRelacionada={hidraRelacionada} t={t} />
                                <Vinculos sensorDC={data} />
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }
}

const FormikForm = withFormik({
    mapPropsToStatus: (props) => {
        return {
            edit: (props && props.edit) || false,
        };
    },
    mapPropsToValues: (props) => {
    //const data = Object.assign({}, props.data);
        return {
        };
    },
    enableReinitialize: true,
    handleSubmit: (values, { props, ...actions }) => {
        props.updateData(values, props);
        actions.setStatus({ edit: false });
    }
})(withTranslation()(SensorForm));

const Sensor = ({ dataFarm }) => {
    const location = useLocation();
    const [_, dispatch] = useContext(FarmContext);
    const sensorId = getSensor(location);
    const farmId = getFarm(location);
    const { t, i18n } = useTranslation();
    const nodesDict = dispatch({ type: "get", path: "nodesDict" });
    const pumpsysDict = dispatch({ type: "get", path: "pumpsysDict" });
    const sectorsDict = dispatch({ type: "get", path: "sectorsDict" });
    const units = dispatch({ type: "get", path: "units" });
    const [nodoRelacionado, setNodoRelacionado] = useState({ nombre: null, parent: null });
    const [hidraRelacionada, setHidraRelacionada] = useState({ hidra: null, parent: null });
    const [sectorsInfo, setSectorsInfo] = useState(null);
    const [info, setInfo] = useState({ data: [], isLoaded: false });

    useEffect(() => {
        setInfo((state) => {
            return { ...state, isLoaded: false };
        });
        if (sensorId !== null) {
            const getDatos = async () => {
                const param = `/farms/${farmId}/sensor/${sensorId}`;
                RestAPI.get("apiAdminDropControl", param)
                    .then(res => JSON.parse(JSON.stringify(res)))
                    .then(json => {
                        setInfo({ isLoaded: true, data: json[0] });
                    })
                    .catch(err => console.error(err));
            };
            getDatos();
        }
    // this runs on initial sensor-page load, so only depends on the id
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sensorId]);

    useEffect(() => {
        const nodo_id = info.data && info.data.nodo_id;
        if (nodesDict && nodesDict[nodo_id]) {
            const m13g = Object.values(nodesDict).find(n => n.tipo === 10) ? true : false;
            const nodo = nodesDict[nodo_id];
            const { nombre, parent } = nodo;
            setNodoRelacionado({ nombre: nombre, parent: m13g ? parent : null });
        }
    }, [nodesDict, info]);

    useEffect(() => {
        if (pumpsysDict !== undefined && pumpsysDict !== null) {
            const equiposConHidra = Object.values(pumpsysDict).filter(eq => Array.isArray(eq.hidraulicas) && eq.hidraulicas.length > 0);
            equiposConHidra.forEach(eq => {
                eq.hidraulicas.forEach(h => {
                    Array.isArray(h.sensores) && h.sensores.length > 0 && h.sensores.forEach(s => {
                        if (s.sensorId == sensorId) {
                            setHidraRelacionada({ hidra: h, parent: eq.equipo_id });
                            return;
                        }
                    });
                });
            });
        }
    }, [pumpsysDict, info]);

    useEffect(() => {
        const arrSectores = [];
        if (sectorsDict !== undefined && sectorsDict !== null) {
            info.data && Array.isArray(info.data.sectores) && info.data.sectores.forEach(sector => {
                sectorsDict[sector] && arrSectores.push(sectorsDict[sector]);
            });
        }
        setSectorsInfo(arrSectores);
    }, [sectorsDict, info]);

    return (
        <div className='row-container'>
            {info.isLoaded === false && <LoadingDialog />}
            <div className='row'>
                <div className='col-12'>
                    <FormikForm
                        farmId={farmId}
                        sensorId={sensorId}
                        data={info.data} isLoaded={info.isLoaded}
                        units={units}
                        updateData={(newData) => callSend(`/farms/${farmId}/sensor/${sensorId}`, info.data, newData, t, i18n, setInfo)}
                        nodoRelacionado={nodoRelacionado}
                        hidraRelacionada={hidraRelacionada}
                    />
                </div>
            </div>

            <div className="card">
                <div className="card-body">
                    <div className='row'>
                        <div className='col col-sm-2 col-md-3 col-lg-4' />
                        <div className='col col-sm-8 col-md-6 col-lg-4 text-center'>
                            <h5 className="card-title">
                                <span>{`${t("farms.zonesTable.title")} (${(Array.isArray(sectorsInfo) && sectorsInfo.length) || 0})`}</span>
                            </h5>
                        </div>
                        <div id="zonesTableToolbar"
                            className='col col-sm-2 col-md-3 col-lg-4 d-flex justify-content-end align-items-center'
                        />
                    </div>
                    <div className='linea-titulo' />
                    {(Array.isArray(sectorsInfo) && sectorsInfo.length > 0) ?
                        <ZonesTable dataFarm={dataFarm} dispatch={dispatch} canEdit={false} sectorsInfo={sectorsInfo} equiposInfo={pumpsysDict} t={t} i18n={i18n} />
                        :
                        <span className='no-data'>{t("forms.noData")}</span>}
                </div>
            </div>
        </div>

    );
};

export default withName(Sensor, "SensorFrag");
